<template>
  <HXContentCard title="Lista de Areas">
    <div class="text-right px-4 mt-4">
      <div class="d-flex justify-content-end">
        <vs-button icon animation-type="vertical" class="mx-1 text-right" id="agregarArea" @click="$router.push('Areas_agregar')">
          <i class="fas fa-plus-circle pr-1"></i>
          Agregar Area
          <template #animate>
            <i class="fas fa-plus-circle"></i>
          </template>
        </vs-button>
        <vs-button id="startButton" v-b-tooltip.hover title="Iniciar tutorial" circle icon danger relief
          @click="startTour">
          <i class="far fa-circle-play mr-1"></i>
          Tutorial Rápido
        </vs-button>
        <!-- tour guide -->
        <TourGuideLineal ref="tourGuide" />
      </div>
    </div>
    <div class="table-responsive px-4 mt-3" id="listadoAreas">
      <table id="datatable_areas" class="table table-bordered table-responsive-md table-striped text-center">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre Área</th>
            <th>Departamento</th>
            <th>Empresa</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in listaItems" :key="item.id">
            <td>
              <strong>
                {{ index + 1 }}
              </strong>
            </td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.departamento.descripcion }}</td>
            <td>{{ item.empresa.nombre }}</td>
            <td style="width: 150px !important" id="opcionesAreas">
              <ButtonGroup :Id="item.id" :data="dataIcons"></ButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </HXContentCard>
</template>
<script>
import { core } from "../../../config/pluginInit";
import ButtonGroup from "../../../components/ButtonGroup/ButtonGroup.vue";
const Swal = require("sweetalert2");
// tour guide
import TourGuideLineal from "@/components/helexium/TourGuideLineal.vue";

export default {
  components: {
    ButtonGroup,
    TourGuideLineal
  },
  name: "DataTable",
  data() {
    return {
      listaItems: [],
      logoEmpresa: "",
      usuario: {},
      dataIcons: [
        {
          type: "success",
          tooltip: "Editar area",
          title: "",
          value: () => 10,
          iconName: "pen",
          color: "rgba(22, 162, 117, 1)",
          tipo: "squared",
          animated: "bounce",
          onActivate: (Id) => {
            console.log("Activated");
            this.$router.push("Areas_editar/" + Id);
          },
          onDeactivate: () => {
            console.log("Deactivate");
          },
        },

        {
          type: "danger",
          tooltip: "Eliminar registro",
          title: "",
          value: () => 0,
          iconName: "trash",
          color: "rgba(22, 162, 117, 1)",
          tipo: "squared",
          animated: "bounce",
          onActivate: (Id) => {
            console.log("Activated");
            this.deleteRow(Id);
          },
          onDeactivate: () => {
            console.log("Deactivate");
          },
        },
      ],

      tourSteps: [
        {
          title: "Areas Registradas",
          description:
            "En este apartado encontrarás las areas asociadas a tu empresa, adicionalmente tienes un buscador el cual ayudará a filtrar los datos más fácilmente.",
          elementId: "listadoAreas",
        },
        {
          title: "Opciones de Areas",
          description:
            "En este apartado encontrarás los botones u opciones que tendremos para editar o eliminar alguna area que ya no necesitemos.",
          elementId: "opcionesAreas",
        },
        {
          title: "Agregar Area",
          description:
            "En este botón podrás registrar o agregar una nueva Area a tu empresa.",
          elementId: "agregarArea",
          redireccionarOtroPasoAPaso: "Areas_agregar" //Nombre de la vista a redireccionar
        },
      ]
  };

},
  async mounted() {
  try {
    this.$isLoading(true);
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    await this.getData();
    core.index();
    window.$("#datatable_areas").DataTable({
      language: {
        url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
      },
    });
    this.$isLoading(false);
  } catch (error) {
    this.$isLoading(false);
    console.log("error", error);
  }
},
methods: {
    async deleteRow(id) {
    Swal.fire({
      title: "Seguro eliminar registro?",
      text: "Después de eliminarlo no podrás recuperarlo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        //let loader = this.$loading.show();
        await this.$store.dispatch("hl_get", {
          path: "Area/Delete/" + id,
        });

        //console.log("res", res);
        //loader.hide()
        await this.getData();

        Swal.fire("Listo!", "Registro eliminado correctamente.", "success");
      }
    });
  },
    async getData() {
    //console.log(this.persona.empresa.id);
    try {
      console.log("departamentoss.....................");
      let res = await this.$store.dispatch("hl_get", {
        path: "Area/ListArea/" + this.usuario.empresa.id,
      });
      console.log("post departamento... ", res);
      if (res.length > 0) {
        this.listaItems = res;
      } else {
        this.listaItems = [];
      }
    } catch (error) {
      this.listaItems = [];
      console.log("err", error);
    }
  },

  startTour() {
    this.$refs.tourGuide.startTour(
      this.tourSteps
    );
  },
},
};
</script>
